/**
 * E2 - A collection of custom HTML elements for building editors
 *
 * This library provides a set of reusable UI components designed specifically
 * for creating level editors, sprite editors, and similar desktop-like web applications.
 */

// Import and register all custom elements
import './elements/app/app';
import './elements/contextmenu/context-menu';
import './elements/contextmenu/context-menu-item';
import './elements/contextmenu/context-menu-menu';
import './elements/contextmenu/context-menu-separator';
import './elements/dialog/alert';
import './elements/dialog/confirm';
import './elements/dialog/dialog';
import './elements/dialog/prompt';
import './elements/keyvalue/keyvalue-editor';
import './elements/listview/list-view';
import './elements/notification/notification';
import './elements/notification/notification-container';
import './elements/panel/collapsible-panel';
import './elements/panel/split-panel';
import './elements/panel/split-panel-container';
import './elements/statusbar/status-bar';
import './elements/statusbar/status-item';
import './elements/statusbar/status-section';
import './elements/tabs/tab';
import './elements/tabs/tab-container';
import './elements/tabs/tab-panel';
import './elements/toolbar/toolbar';
import './elements/toolbar/toolbar-button';
import './elements/toolbar/toolbar-menu';
import './elements/toolbar/toolbar-separator';
import './elements/treeview/tree-view';

// Export types and interfaces for TypeScript users
export * from './types';

// Export utility functions if any
export * from './utils';

// Version information
export const VERSION = '1.0.0';

// Auto-registration message for development
// @ts-ignore
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log(
    `E2 v${VERSION} loaded - Custom elements registered automatically`
  );
}
